import React from 'react';

const LogoutConfirmModal = ({ showLogoutConfirm, setShowLogoutConfirm, handleSignOut }) => {
  if (!showLogoutConfirm) return null;
  
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4 text-center">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-25 transition-opacity"
          aria-hidden="true"
          onClick={() => setShowLogoutConfirm(false)}
        />

        {/* Modal */}
        <div className="relative inline-block w-full max-w-sm transform overflow-hidden rounded-xl bg-white p-6 text-left align-middle shadow-2xl transition-all">
          <h3 className="text-lg font-semibold leading-6 text-gray-900">
            Sign out
          </h3>
          
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Are you sure you want to sign out?
            </p>
          </div>

          <div className="mt-5 flex space-x-3">
            <button
              type="button"
              className="inline-flex justify-center rounded-md px-4 py-2 text-sm font-medium text-white bg-brand-teal hover:bg-brand-teal-dark transition-colors focus:outline-none"
              onClick={handleSignOut}
            >
              Yes, sign out
            </button>
            <button
              type="button"
              className="inline-flex justify-center rounded-md px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors focus:outline-none"
              onClick={() => setShowLogoutConfirm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmModal; 